import { ElementRef, useCallback, useState } from 'react';

import { MetricCardsData } from 'Deer/metricCards/MetricCards';
import { GOALS_OVERVIEW_PAGE_METRIC_CARDS } from 'Deer/metricCards/constants';
import { AgGridReact } from 'ag-grid-react';
import useOrganisationSettings from 'components/hooks/useOrganisationSettings';

import { modifyString, StringModifier } from 'constants/copyHelpers';
import { minifyNumber } from 'constants/numberMinifyHelper';

export const useGroupByIndividualData = ({ gridRef }: { gridRef: ElementRef<typeof AgGridReact> }) => {
  const { keyResultsName } = useOrganisationSettings();

  const [chartData, setChartData] = useState<{
    isLoading: boolean;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    rowData: any[];
  }>({
    isLoading: true,
    rowData: [],
  });

  const [cardKPIData, setCardKPIData] = useState<MetricCardsData[]>([]);

  const onModalUpdated = useCallback(() => {
    const totalIndividuals = [];
    // @ts-expect-error current is possibly null
    gridRef?.current?.api?.forEachNodeAfterFilterAndSort((row) => {
      totalIndividuals.push(row?.data);
    });

    const individualsWithNoCheckIns = totalIndividuals.filter((row) => !row.lastCheckInDate);
    const individualWithZeroKeyResults = totalIndividuals.filter((row) => !row.keyResultCount);
    const sumOfAllProgresses = totalIndividuals.reduce((prev, cur) => (cur?.avgProgress || 0) + prev, 0);
    const avgProgressPercentage = sumOfAllProgresses / (totalIndividuals.length || 1);

    setCardKPIData([
      // {
      //   title: `Total no. of individuals`,
      //   value: totalIndividuals.length,
      // },
      // {
      //   title: `Individuals who own no ${modifyString(keyResultsName, StringModifier.PLURAL_SENTENCE_CASE)}`,
      //   value: individualWithZeroKeyResults.length,
      // },
      // { title: `Individuals who've never checked-in`, value: individualsWithNoCheckIns.length },
      // {
      //   title: `Average progress percentage`,
      //   value: `${minifyNumber(Number(avgProgressPercentage || 0))}%`,
      // },

      {
        cardId: GOALS_OVERVIEW_PAGE_METRIC_CARDS.directReports.teamMemberNoGoals,
        title: `Team members without any ${modifyString(keyResultsName, StringModifier.PLURAL_SENTENCE_CASE)}`,
        subTitle: '',
        value: individualWithZeroKeyResults.length,
        color: '',
      },
      {
        cardId: GOALS_OVERVIEW_PAGE_METRIC_CARDS.directReports.teamMemberNoCheckIn,
        title: 'Team members with no check-ins',
        subTitle: '',
        value: individualsWithNoCheckIns.length,
        color: '',
      },
      {
        title: 'Average progress',
        value: `${minifyNumber(Number(avgProgressPercentage || 0))}%`,
      },
    ]);
  }, [gridRef, keyResultsName]);

  return {
    chartData,
    setChartData,
    cardKPIData,
    isLoading: chartData.isLoading,
    onModalUpdated,
  };
};
